import { EpimsBaseEntityDto } from './epim-base.dto';
export class AssetStatusDto extends EpimsBaseEntityDto {
  
  AssetStatusName: string;
  SubscriptionUserId: string;  
  Version: number;
}
